import {
  CustomFieldType,
  type CustomFieldDefinition,
} from "@repo/app-types/entities/customField";
import type { CustomFieldCondition } from "@repo/app-types/entities/filterConditions";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { SimpleMenuPopover } from "@repo/ui/Menu/simpleMenuPopover";
import type { FC } from "react";
import { SubmenuTrigger } from "react-aria-components";
import { BooleanCustomFieldConditionMenu } from "./booleanCustomFieldConditionMenu.js";
import { DateCustomFieldConditionMenu } from "./dateCustomFieldConditionMenu.js";
import { StringCustomFieldConditionMenu } from "./stringCustomFieldConditionMenu.js";

export interface CustomFieldConditionMenuProps {
  customFieldDefinition: CustomFieldDefinition;
  onSelect: (condition: CustomFieldCondition) => void;
}

export const CustomFieldConditionMenu: FC<CustomFieldConditionMenuProps> = (
  props,
) => {
  const handleHasAnyValueSelect = () => {
    props.onSelect({
      customFieldDefinitionId: props.customFieldDefinition.id,
      operator: "has_any_value",
    });
  };

  if (
    props.customFieldDefinition.field_type === CustomFieldType.Date ||
    props.customFieldDefinition.field_type === CustomFieldType.DateAndTime
  ) {
    return (
      <DateCustomFieldConditionMenu
        customFieldDefinitionId={props.customFieldDefinition.id}
        fieldType={props.customFieldDefinition.field_type}
        onSelect={props.onSelect}
      />
    );
  }

  return (
    <SimpleMenu aria-label="Custom field condition">
      <SubmenuTrigger>
        <SimpleMenuItem>is equal to...</SimpleMenuItem>

        <SimpleMenuPopover>
          {props.customFieldDefinition.field_type ===
          CustomFieldType.Boolean ? (
            <BooleanCustomFieldConditionMenu
              customFieldDefinitionId={props.customFieldDefinition.id}
              onSelect={props.onSelect}
            />
          ) : (
            <StringCustomFieldConditionMenu
              customFieldDefinitionId={props.customFieldDefinition.id}
              onSelect={props.onSelect}
            />
          )}
        </SimpleMenuPopover>
      </SubmenuTrigger>

      <SimpleMenuItem onAction={handleHasAnyValueSelect}>
        is not empty
      </SimpleMenuItem>
    </SimpleMenu>
  );
};
